import { enumResources } from './enum-resources';
import { formsResources } from './forms-resource';

const rib = {
  IBAN: 'IBAN',
  BIC: 'BIC',
  BANKNAME: 'Nom de la banque',
  HOLDER_FIRSTNAME: 'Prénom titul.',
  HOLDER_LASTNAME: 'Nom titul.',
};

const representativeResources = {
  FIRSTNAME: 'Prénom du représentant légal',
  LASTNAME: 'Nom du représentant légal',
};

export const sharedResources = {
  // A
  ADDRESS: 'Adresse',
  AGENCY: 'Intermédiaire',
  AGENCIES: 'Intermédiaires',
  AGENCYSTATUS: 'Statut',
  // B
  BIRTHDATE: 'Date de naissance',
  // C
  CAPITAL: 'Capital social',
  CITY: 'Ville',
  CITY_RCS: 'Ville (RCS)',
  COMPANYNAME: 'Raison sociale',
  COMPANY_TYPE: 'Forme Juridique',
  CONTINUE: 'Continuer',
  CREATION_DATE: 'Date de création',
  // D
  DOCUMENT_TYPE: 'Type de document',
  DOCUMENT_STATE: 'Statut du document',
  DOCUMENT_STATE_ENUM: 'Statut du document',
  // E
  EMAIL: 'Email',
  ENUM: enumResources,
  EFFECTIVEDATE: "Date d'effet",

  // F
  FIRSTNAME: 'Prénom',
  FORMS: formsResources,
  FUNCTION: 'Fonction',
  // G
  // H
  HEADOFFICE: 'Siège social',
  HEADOFAGENCY: 'Responsable légal',
  // I
  INTERACTION: {
    OPEN_NEWTAB: 'Ouvrir dans un onglet',
  },
  // J
  // K
  KBIS_EDITION_DATE: "Date d'édition du KBIS",
  // L
  LASTNAME: 'Nom',
  LOGIN: 'Se connecter',
  // M
  MOBILE: 'Téléphone portable',
  // N
  // O
  OFFICENAME: 'Nom du cabinet',
  ORIAS_NUMBER: 'N° Orias',
  // P
  PASSWORD: 'Mot de passe',
  PASSWORD_AGAIN: 'Ressaisir le mot de passe',
  PICK_FILE: 'Choisir un fichier',
  PHONE: 'Téléphone fixe',
  // Q
  // R
  RC_VALIDITY_END: 'Fin de validité ORIAS',
  RCSNUMBER: 'N° RCS',
  REGISTRATION_NUMBER: "Numéro d'immatriculation ORIAS",
  REGISTER: "S'enregistrer",
  REPRESENTATIVE: representativeResources,
  RESET_PASSWORD: 'Récupérer votre mot de passe',
  RIB: rib,
  // S
  SAVE: 'Enregistrer',
  SAVE_ALL: 'Enregistrer tout',
  SIREN_NUMBER: 'N° SIREN',
  SIRET_NUMBER: 'N° SIRET',
  SIRET_SIREN_NOTMATCHING: 'Le SIRET devrait débuter par le SIREN',
  SUBSCRIBE: "S'inscrire",
  SUBSCRIPTION: 'Souscription',
  // T
  // U
  // V
  // W
  WARNING: 'Attention',
  // X
  // Y
  // Z
};
